import React, { useEffect, useState } from "react";
import axios, { all } from "axios";
const Archiv = () => {
  const [allDocuments, setAllDocuments] = useState([]);
  const documents = async () => {
    try {
      const response = await axios.post(
        "https://api.bbf-bike.de/api/documents/downloads",
        { data: "bbf-bike/documents" },
      );
      setAllDocuments(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    window.scrollTo(0,0);
    documents();
  }, []);
  const findBrandDocuments = (cat, brand) => {
    const documents = allDocuments.filter(
      (item) =>
        item.toLowerCase().includes(brand) && item.toLowerCase().includes(cat),
    );
    return documents;
  };

  const bbfDocuments = {
    catalogs: findBrandDocuments("katalog", "bbf").sort((a, b) => {
      const numA = parseInt(a.match(/\d+/)[0]);
      const numB = parseInt(b.match(/\d+/)[0]);
      return numB - numA;
    }),
    ces: findBrandDocuments("ce", "bbf").reverse(),
  };
  const vivaDocuments = {
    catalogs: findBrandDocuments("katalog", "viva").reverse(),
    ces: findBrandDocuments("ce", "viva").reverse(),
  };
  const checkerPigDocuments = {
    catalogs: findBrandDocuments("katalog", "checker").reverse(),
    ces: findBrandDocuments("ce", "cp").reverse(),
  };
  const columbusDocuments = {
    catalogs: findBrandDocuments("katalog", "columbus").reverse(),
    ces: findBrandDocuments("ce", "col").reverse(),
  };
  const dahonDocuments = {
    catalogs: findBrandDocuments("katalog", "dahon").reverse(),
    ces: findBrandDocuments("ce", "dahon").reverse(),
  };
  const pantherDocuments = {
    catalogs: findBrandDocuments("katalog", "panther").reverse(),
    ces: findBrandDocuments("ce", "pan").reverse(),
  };
  const lehmkuhlDocuments = {
    catalogs: findBrandDocuments("katalog", "lehmkuhl").reverse(),
    ces: findBrandDocuments("ce", "leh").reverse(),
  };
  const bottecchiaDocuments = {
    catalogs: findBrandDocuments("katalog", "bottecchia").sort((a, b) => {
      const numA = parseInt(a.match(/\d+/)[0]);
      const numB = parseInt(b.match(/\d+/)[0]);
      return numB - numA;
    }),
    ces: findBrandDocuments("ce", "bottecchia").reverse(),
  };
  const stailDocuments = {
    catalogs: findBrandDocuments("katalog", "stail").reverse(),
    ces: findBrandDocuments("ce", "stail").reverse(),
  };
  const documentsByBrands = [
    {
      brand: "BBF Bike",
      documents: bbfDocuments,
    },
    {
      brand: "Checker Pig",
      documents: checkerPigDocuments,
    },
    {
      brand: "Columbus",
      documents: columbusDocuments,
    },
    {
      brand: "Dahon",
      documents: dahonDocuments,
    },
    {
      brand: "Panther",
      documents: pantherDocuments,
    },
    {
      brand: "Lehmkuhl",
      documents: lehmkuhlDocuments,
    },
    {
      brand: "Bottecchia",
      documents: bottecchiaDocuments,
    },
    {
      brand: "Viva",
      documents: vivaDocuments,
    },
    {
      brand: "Stail",
      documents:stailDocuments
    }
  ];

  return (
    <div className="min-h-screen h-auto flex justify-center items-center w-full">
      <div className="flex justify-space-between md:flex-row items-stretch w-full sm:flex-col-reverse">
        <div className="flex-1">
          <img
            src="https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/archiv_cover.webp"
            alt="archiv_cover"
            className="object-cover h-full w-full"
          />
        </div>
        <div className="flex-1 bg-bbf-black text-bbf-white">
          <div className="md:pt-52 sm:pt-14 sm:px-5 md:pb-20 sm:pb-8 md:px-20 flex flex-col justify-start items-start gap-8">
            {documentsByBrands.map((item, i) => (
              <div
                key={i}
                className="flex flex-col justify-start items-start gap-2">
                <div className="font-roboto font-extrabold text-2xl uppercase">
                  {item.brand}
                </div>
                <div className="flex md:gap-12 sm:flex-col sm:gap-4 md:flex-row">

                  {item.documents.catalogs.length > 0 ? (
                                      <div className="flex flex-col justify-start items-start gap-2">
                    <div className="font-roboto font-semibold uppercase mt-4">
                      Kataloge
                    </div>
                    {item.documents.catalogs.map((cat, index) => (
                      <div key={index} className="w-full flex flex-col gap-1">
                        <a
                          href={`https://media.bbf-bike.de/shop/documents/bbf-bike/documents/${cat}`}
                          target="_blank">
                          {cat.replaceAll("_", " ").replace(".pdf", "")}
                        </a>
                        <div className="w-full h-[2px] bg-bbf-green"></div>
                      </div>
                    ))}
                  </div>
                  ):""}


                  {item.documents.ces.length > 0 ? (
                    <div className="flex flex-col justify-start items-start gap-2 mt-4">
                      <div className="font-roboto font-semibold uppercase">
                        CE-KONFORMITÄTSERKLÄRUNG
                      </div>
                      {item.documents.ces.map((ce, index) => (
                        <div key={index} className="w-full flex flex-col gap-1">
                          <a
                            href={`https://media.bbf-bike.de/shop/documents/bbf-bike/documents/${ce}`}
                            target="_blank">
                            {ce.replaceAll("_", " ").replace(".pdf", "")}
                          </a>
                          <div className="w-full h-[2px] bg-bbf-green"></div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Archiv;
